import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import type { DocumentDetailPayload } from '@Application/Beneficiaries/Documents/Actions/documentFetched';
import documentListItemMoved, {
	type DocumentListItemMovedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentListItemMoved';
import documentListItemMoveFailed, {
	type DocumentListItemMoveFailedAction,
} from '@Application/Beneficiaries/Documents/Actions/documentListItemMoveFailed';
import type MoveDocumentListItem from '@Application/Beneficiaries/Documents/Commands/MoveDocumentListItem';
import { post } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = DocumentListItemMovedAction | DocumentListItemMoveFailedAction;

export default (command: MoveDocumentListItem) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await post<DocumentDetailPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/documents/${command.documentId}/lists/${encodeURIComponent(command.listKey)}/item-moves`,
				command.toJSON(),
			);

			const action = documentListItemMoved(payload);
			dispatch(action);
			return action;
		} catch (error) {
			const action = documentListItemMoveFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
